var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"max-width",staticStyle:{"margin-top":"3.125vw"}},[_c('enter-btn',{staticStyle:{"margin-bottom":"60px"}}),_c('policy-month',{staticStyle:{"margin-bottom":"100px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }